import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";

export interface IExportImportClient {
    /**
     * Odešle data označena k exportu na službu
     * @param jsonData Data k exportu
     * @param cancellationToken Umožňuje stornovat běžící dotaz
     */
    export(jsonData: readonly INode[], cancellationToken?: CancellationToken): Promise<string>;

    /**
     * Odešle soubor, který má být použit pro import dat
     * @param docTempId Temp id dokumentu na DMS
     * @param cancellationToken Umožňuje stornovat běžící dotaz
     */
    import(docTempId: string, cancellationToken?: CancellationToken): Promise<string>;

    /**
     * Zkontroluje předanou podmínku
     * @param condition Podmínka
     * @param objectName Název objektu, ke kterému se podmínka vztahuje
     * @param cancellationToken Umožňuje stornovat běžící dotaz
     */
    checkCondition(condition: string, objectName: string, cancellationToken?: CancellationToken): Promise<boolean>;

    /**
     * Načte seznam názvů tříd
     * @param cancellationToken Umožňuje stornovat běžící dotaz
     */
    getClassNames(cancellationToken?: CancellationToken): Promise<string[]>;
}

interface IGlobalNode {
    name: string;
}

interface IObjectNode {
    isObject: true;
    className?: string;
    condition?: string;
    isPersistent?: boolean;
    children?: INode[];
}

interface IOtherNode {
    isObject: false;
}

export type INode = IGlobalNode & (IObjectNode | IOtherNode);
